import { useState, useMemo, useEffect } from "react";
import Quadrant from "./Quadrant";
// import { useModuleControls } from "../context/ModuleControlsContext";
import { useMetric, useInvert } from "../context/ModuleControlsContext";
import "./ModuleCard.css";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import OpenWithIcon from "@mui/icons-material/OpenWith";

import TEMP_IMG from '../../../assets/img/temperature.png'
import TEMP_IMG_N from '../../../assets/img/temperature.png'

import O2_IMG from '../../../assets/img/image.png'
import O2_IMG_N from '../../../assets/img/image.png'

import SO2_IMG from '../../../assets/img/image.png'
import SO2_IMG_N from '../../../assets/img/image.png'

// const O2_IMG =   `${process.env.PUBLIC_URL}/img/oxigeno.png`;
// const O2_IMG_N =   `${process.env.PUBLIC_URL}/img/o2_naranjo.png`;


function sortCansByNumber(cans = []) {
  return [...cans].sort((a, b) => {
    const numA = parseInt(a?.can?.match(/\d+/)?.[0] || 0, 10);
    const numB = parseInt(b?.can?.match(/\d+/)?.[0] || 0, 10);
    return numA - numB;
  });
}

function getCanStorageKey(moduloId) {
  return `nanoox.module-can-order.${String(moduloId ?? "default")}`;
}

function loadStoredOrder(storageKey) {
  if (typeof window === "undefined") {
    return [];
  }

  try {
    const parsed = JSON.parse(window.localStorage.getItem(storageKey) ?? "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

function persistOrder(storageKey, orderedKeys) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(orderedKeys));
  } catch (error) {
    // ignore persistence errors
  }
}

function getCanKey(canItem, index) {
  return String(canItem?.can ?? `can-${index}`);
}

function normalizeCanOrder(cans = [], storedOrder = []) {
  const fallbackSortedCans = sortCansByNumber(cans);
  const canMap = new Map(fallbackSortedCans.map((canItem, index) => [getCanKey(canItem, index), canItem]));
  const nextOrderedCans = [];

  storedOrder.forEach((canKey) => {
    const foundCan = canMap.get(canKey);
    if (!foundCan) {
      return;
    }

    nextOrderedCans.push(foundCan);
    canMap.delete(canKey);
  });

  canMap.forEach((canItem) => {
    nextOrderedCans.push(canItem);
  });

  return nextOrderedCans;
}

function HoverIcon({ src, hoverSrc, alt }) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <img
      className="icon"
      src={isHovered ? hoverSrc : src}
      alt={alt}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
}

export default function ModuleCard({ modulo, modulosLength, showControls = false, generador, controlType, userLevel, modulo_id, translate , statusGeneradorManual, selectedCenter,   dragDropEnabled = false,
  onToggleDragDrop,}) {

  // const { globalMetric, setGlobalMetric, toggleInvert } = useModuleControls();
  const { globalMetric, setGlobalMetric } = useMetric();
  const { toggleInvert } = useInvert();

  const [canPage, setCanPage] = useState(0);

  const [orderedCans, setOrderedCans] = useState([]);
  const [draggedCanKey, setDraggedCanKey] = useState(null);
  const [dragOverCanKey, setDragOverCanKey] = useState(null);
  const isDraggingCanLayout = draggedCanKey !== null;


  // const cans = modulo.cans || [];
  // const cans = (modulo.cans || []).filter(c => Array.isArray(c?.bombas) && c.bombas.length > 0);
  const cans = useMemo(() => {
    return (modulo.cans || []).filter(
      (c) => Array.isArray(c?.bombas) && c.bombas.length > 0
    );
  }, [modulo.cans]);

  const isSingleModule = modulosLength === 1;

  const cansPerPage = isSingleModule ? 6 : 3;
  const totalPages = Math.ceil(cans.length / cansPerPage);

  const groupedCans = [];
  for (let i = 0; i < orderedCans.length; i += cansPerPage) {
    groupedCans.push(orderedCans.slice(i, i + cansPerPage));
  }

  const [rotate, setRotate] = useState(false);
  
  const metricOrder = ["O2", "SO2", "Temp"];


  const canOrderStorageKey = useMemo(() => getCanStorageKey(modulo_id), [modulo_id]);
  const canEditLayout = dragDropEnabled;



  // Función que avanza la métrica al siguiente valor
  const cycleMetric = () => {
    // activa la animación
    setRotate(true);

    // cambia a la siguiente métrica del ciclo
    const currentIndex = metricOrder.indexOf(globalMetric);
    const nextIndex = (currentIndex + 1) % metricOrder.length;
    setGlobalMetric(metricOrder[nextIndex]);

    // desactiva la animación después
    setTimeout(() => setRotate(false), 400);
  };


  const metricIcons = {
    O2:   <HoverIcon src={O2_IMG} hoverSrc={O2_IMG_N} alt="oxígeno" />,
    SO2:  <HoverIcon src={SO2_IMG} hoverSrc={SO2_IMG_N} alt="saturación" />,
    Temp: <HoverIcon src={TEMP_IMG} hoverSrc={TEMP_IMG_N} alt="temperatura" />,
  };


  useEffect(() => {
    setOrderedCans(normalizeCanOrder(cans, loadStoredOrder(canOrderStorageKey)));
  }, [canOrderStorageKey, cans]);


  const moveCan = (sourceKey, targetKey) => {
    if (!canEditLayout || !sourceKey || !targetKey || sourceKey === targetKey) {
      return;
    }

    setOrderedCans((currentCans) => {
      const nextCans = [...currentCans];
      const sourceIndex = nextCans.findIndex((canItem, index) => getCanKey(canItem, index) === sourceKey);
      const targetIndex = nextCans.findIndex((canItem, index) => getCanKey(canItem, index) === targetKey);

      if (sourceIndex < 0 || targetIndex < 0) {
        return currentCans;
      }

      const [movedCan] = nextCans.splice(sourceIndex, 1);
      nextCans.splice(targetIndex, 0, movedCan);
      persistOrder(
        canOrderStorageKey,
        nextCans.map((canItem, index) => getCanKey(canItem, index))
      );
      return nextCans;
    });
  };


  const [openMenu, setOpenMenu] = useState(false);

  return (
    <div className="module-card">
      <div className="module-header">

        {showControls && (
          <div className="module-controls">
            {/* Botón para invertir bombas */}
            <button className="invert-btn" onClick={toggleInvert}>
              <SwapVertIcon style={{color:'#c3c3c3', fontSize:'1.2vw'}} />
            </button>
            {/* Botón principal con el icono actual */}
            <div className="metric-dropdown">
              {/* Botón que cicla la métrica con cada click */}
              <button className={`metric-icon ${rotate ? "metric-rotate" : ""}`} onClick={cycleMetric}>
                {metricIcons[globalMetric]}
              </button>
            </div>

            <button
              className={`metric-icon drag-toggle-btn ${dragDropEnabled ? "is-active" : ""}`}
              onClick={onToggleDragDrop}
              title={dragDropEnabled ? "Desactivar drag and drop" : "Activar drag and drop"}
              aria-label={dragDropEnabled ? "Desactivar drag and drop" : "Activar drag and drop"}
            >
              <OpenWithIcon style={{ fontSize: "1.2vw" }} />
            </button>
          </div>
        )}
        <h2>{translate('modulo')} {modulo.id}</h2>

        {totalPages > 1 && (
          <div className="cans-pagination">
            <button
              disabled={canPage <= 0}
              onClick={() => setCanPage((p) => Math.max(p - 1, 0))}
            >
              ◀
            </button>
            <span>
              {canPage + 1} / {totalPages}
            </span>
            <button
              disabled={canPage >= totalPages - 1}
              onClick={() => setCanPage((p) => Math.min(p + 1, totalPages - 1))}
            >
              ▶
            </button>
          </div>
        )}
      </div>
      {/* cans */}
      <Quadrant 
        translate={translate} 
        statusGeneradorManual={statusGeneradorManual} 
        canPage={canPage} 
        cansLenght={cans.length} 
        groupedCans={groupedCans} 
        isSingleModule={isSingleModule}
        generador={generador} 
        controlType={controlType} 
        userLevel={userLevel} 
        modulo_id={modulo_id} 
        selectedCenter={selectedCenter}
        dragDropEnabled={dragDropEnabled}
        canEditLayout={canEditLayout}
        draggedCanKey={draggedCanKey}
        dragOverCanKey={dragOverCanKey}
        isDraggingCanLayout={isDraggingCanLayout}
        onCanDragStart={setDraggedCanKey}
        onCanDragEnd={() => {
          setDraggedCanKey(null);
          setDragOverCanKey(null);
        }}
        onCanDragOver={setDragOverCanKey}
        onCanMove={moveCan}
      />
    </div>
  );
}
